import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedures/parentalLeaveSupportAllowance/index'
import {Request} from 'pages/withAuth/adminPage/procedures/parentalLeaveSupportAllowance/request'
import {ParentalLeaveSupportAllowanceFlow} from 'pages/withAuth/adminPage/procedures/parentalLeaveSupportAllowance/flow'
import {Confirm} from 'pages/withAuth/adminPage/procedures/parentalLeaveSupportAllowance/confirm'

export const ParentalLeaveSupportAllowanceRoutes: RouteParams[] = [
  {
    key: 'parental_leave_support_allowance',
    path: WITH_AUTH_ADMIN_PATHS.PARENTAL_LEAVE_SUPPORT_ALLOWANCE.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: 'parental_leave_support_allowance/request',
    path: WITH_AUTH_ADMIN_PATHS.PARENTAL_LEAVE_SUPPORT_ALLOWANCE.REQUEST,
    component: Request,
    exact: true,
  },
  {
    key: 'parental_leave_support_allowance/flow/:id',
    path: WITH_AUTH_ADMIN_PATHS.PARENTAL_LEAVE_SUPPORT_ALLOWANCE.FLOW,
    component: ParentalLeaveSupportAllowanceFlow,
    exact: true,
  },
  {
    key: 'parental_leave_support_allowance/confirm/:id',
    path: WITH_AUTH_ADMIN_PATHS.PARENTAL_LEAVE_SUPPORT_ALLOWANCE.CONFIRM,
    component: Confirm,
    exact: true,
  },
]
